import React from 'react';

const TermsAndConditions = () => {
  const updated = new Date().toLocaleDateString(undefined, {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
  });

  return (
    <div className="container py-5">
      <div className="row justify-content-center">
        <div className="col-lg-10">
          <div className="card shadow-sm">
            <div className="card-body p-4 p-md-5">
              <header className="mb-4 mb-md-5">
                <h1 className="h2 fw-bold mb-2">Terms & Conditions</h1>
                <p className="text-muted mb-0">Last updated: {updated}</p>
              </header>

              <section className="mb-4">
                <p>
                  Welcome to <strong>ProspectPulse</strong> ("Company", "we", "our", or "us"). These Terms & Conditions ("Terms")
                  govern your access to and use of our website, products, and services, including our application
                  <strong> Nurturix</strong> (collectively, the "Services"). By accessing or using the Services, you agree to be bound by these Terms.
                  If you do not agree, please do not use the Services.
                </p>
              </section>

              <section className="mb-4">
                <h2 className="h5 fw-semibold">1. Who We Are</h2>
                <p className="mb-0">
                  ProspectPulse is headquartered in <strong>Bilaspur, Chhattisgarh, India (PIN 495006)</strong>. All policies, practices,
                  and any disputes arising from these Terms are governed by the laws of the State of Chhattisgarh (C.G.), India,
                  without regard to conflict of law principles.
                </p>
              </section>

              <section className="mb-4">
                <h2 className="h5 fw-semibold">2. Use of the Website/App</h2>
                <ul className="ps-4 mb-0">
                  <li className="mb-2">Use the Services only for lawful purposes and in accordance with applicable laws and these Terms.</li>
                  <li className="mb-2">
                    <strong>Nurturix is provided “as is”.</strong> You agree not to misuse, reverse engineer, interfere with, circumvent
                    security features, or use the Services in a way that infringes on the rights of others or violates applicable laws.
                    If violated, your subscription may be suspended or cancelled without refund where permitted by these Terms.
                  </li>
                  <li className="mb-0">You are responsible for maintaining the confidentiality of your account credentials and all activities under your account.</li>
                </ul>
              </section>

              <section className="mb-4">
                <h2 className="h5 fw-semibold">3. Intellectual Property Rights</h2>
                <p className="mb-0">
                  All content, features, and functionality of the Services — including software, text, graphics, logos, icons,
                  images, audio, video, and the design, selection, and arrangement thereof — are owned by ProspectPulse or its
                  licensors and are protected by Indian and international intellectual property laws. Except as expressly permitted
                  in writing by us, you may not copy, modify, reproduce, distribute, transmit, display, perform, create derivative
                  works from, or otherwise exploit any part of the Services. “ProspectPulse”, “Nurturix”, our logos, and trade dress
                  are our trademarks/service marks. All rights are reserved.
                </p>
              </section>

              <section className="mb-4">
                <h2 className="h5 fw-semibold">4. Plans, Pricing & Taxes</h2>
                <p>Pricing below is provided as shared and may be updated from time to time on our website or via written notice. All prices are exclusive of applicable taxes unless stated otherwise.</p>
                <ul className="ps-4 mb-2">
                  <li className="mb-1"><strong>6‑month term</strong> (paid upfront): <strong>₹1,099</strong> per month + applicable tax.</li>
                  <li className="mb-1"><strong>13‑month term</strong> (paid upfront): <strong>₹899</strong> per month + applicable tax.</li>
                  <li className="mb-1"><strong>13‑month term</strong> (paid upfront): <strong>₹1,399</strong> per month + applicable tax.</li>
                </ul>
                <p className="text-muted small mb-0">Note: Where a plan is paid upfront for the full term, cancellation does not create any right to a pro‑rata refund except as stated under our Refund Policy below.</p>
              </section>

              <section className="mb-4">
                <h2 className="h5 fw-semibold">5. Refunds, Cancellations & Renewals</h2>
                <ul className="ps-4 mb-0">
                  <li className="mb-2"><strong>20‑day full refund policy:</strong> Cancel within the first 20 days of a new subscription start date to receive a full refund of subscription fees paid for that order.</li>
                  <li className="mb-2"><strong>No refunds after 20 days:</strong> After the 20‑day window elapses, payments are non‑refundable.</li>
                  <li className="mb-2"><strong>Returned/returning customers:</strong> If you restart or purchase a new subscription after cancellation, the 20‑day refund policy applies again to that new subscription.</li>
                  <li className="mb-0"><strong>Cancellations affect future cycles only:</strong> You may cancel at any time; cancellation stops the next upcoming cycle or renewal. For prepaid terms, access continues to term end; no pro‑rated refunds unless within the 20‑day window.</li>
                </ul>
              </section>

              <section className="mb-4">
                <h2 className="h5 fw-semibold">6. Payment Processing</h2>
                <p className="mb-0">You authorize us (and our payment processor) to charge your selected payment method for plan fees, including applicable taxes. You agree to keep your billing information accurate and current.</p>
              </section>

              <section className="mb-4">
                <h2 className="h5 fw-semibold">7. Privacy</h2>
                <p className="mb-0">
                  We care about your privacy. Please review our
                  {' '}<a className="text-decoration-none" href="/privacy-policy">Privacy Policy</a>{' '}to understand how we collect, use, and protect your information.
                </p>
              </section>

              <section className="mb-4">
                <h2 className="h5 fw-semibold">8. Disclaimers</h2>
                <ul className="ps-4 mb-0">
                  <li className="mb-2">The Services are provided on an <em>“as is” and “as available”</em> basis without warranties of any kind, whether express or implied.</li>
                  <li className="mb-0">We do not warrant that the Services will be uninterrupted, timely, secure, or error‑free.</li>
                </ul>
              </section>

              <section className="mb-4">
                <h2 className="h5 fw-semibold">9. Limitation of Liability</h2>
                <p className="mb-0">
                  To the maximum extent permitted by law, ProspectPulse shall not be liable for any indirect, incidental, special, consequential, or punitive damages, or any loss of profits or revenues, whether incurred directly or indirectly, or any loss of data, use, goodwill, or other intangible losses resulting from your use of (or inability to use) the Services, unauthorized access, or other related matters.
                </p>
              </section>

              <section className="mb-4">
                <h2 className="h5 fw-semibold">10. Suspension & Termination</h2>
                <p className="mb-0">
                  We may suspend or terminate access to the Services immediately, without prior notice or liability, for any breach of these Terms or where required by law. Upon termination, your right to use the Services will cease immediately. Certain provisions survive termination (e.g., IP, disclaimers, limitations of liability, governing law).
                </p>
              </section>

              <section className="mb-4">
                <h2 className="h5 fw-semibold">11. Governing Law & Jurisdiction</h2>
                <p className="mb-0">
                  These Terms are governed by and construed in accordance with the laws of the State of Chhattisgarh, India. You agree to the exclusive jurisdiction of the courts located in Chhattisgarh for dispute resolution.
                </p>
              </section>

              <section className="mb-4">
                <h2 className="h5 fw-semibold">12. Changes to These Terms</h2>
                <p className="mb-0">We may update these Terms from time to time. Changes are effective when posted on our website or otherwise communicated. Your continued use of the Services after any change constitutes acceptance.</p>
              </section>

              <section>
                <h2 className="h5 fw-semibold">13. Contact Information</h2>
                <address className="mb-0">
                  ProspectPulse<br />
                  Bilaspur, C.G. 495006, India<br />
                  Email: <a className="text-decoration-none" href="mailto:support@prospectpulse.in">support@prospectpulse.in</a>
                </address>
                <p className="text-muted small mt-3 mb-0">This page is intended to set clear expectations and protect both parties. For specific legal questions, please consult a qualified attorney.</p>
              </section>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TermsAndConditions;
